import { render, staticRenderFns } from "./sceTab.vue?vue&type=template&id=872c7ea8&scoped=true"
import script from "./sceTab.vue?vue&type=script&lang=js"
export * from "./sceTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872c7ea8",
  null
  
)

export default component.exports